import { Component, ViewChild } from '@angular/core';
import { WebParameterContext } from '../../../../model/common';
import {  IonInfiniteScroll} from '@ionic/angular';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { NativeService } from '../../../../service/native.service';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var app;
@Component({
  selector: 'app-questionnaire-investigation',
  templateUrl: './questionnaire-investigation.component.html',
  styleUrls: ['./questionnaire-investigation.component.scss']
})
export class QuestionnaireInvestigationComponent extends GridBaseCase {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  searchValue:any="";
  apiObj = {
    status: false,
    msg: ''
  };
  RecordCount: Number = 0;//列表总数量
  loading: boolean = false;//加载效果
  arrayData:Array<any> = new Array<any>();
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal,
    public native:NativeService
  ) { 
    super();
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.arrayData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    that.loading = true;
    // return;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    //debugger;
   
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName="GetSncBySrl";
    body.OpType = "query";
    body.ConfigType = "view";
    // body.RowsPerPage = 15;
    body.PageNumber =PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Content";
    body.Client.ClientType = 2;
    body.Client.Name = "temp_content";
     //  body.RequestBody={};
     //  body.RequestBody=JSON.stringify(_arrayList);
      // body.RequestBody=JSON.stringify( {});
    body.RequestBody = {};
    let obj={};

    obj["storeid"]=that.com.GetStorageKey("tbstore")["ID"];
    if(that.searchValue){
      obj["userName"]=that.searchValue;
    }
    body.RequestBody =JSON.stringify( obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
         /****判断是否第一页begin****/
         if(PageNumber == 1){
          that.arrayData = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          that.infiniteScroll.complete();
        }
        /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.forEach(item=>{
          item.ChineseName=that.com.FormatName(item.ChineseName||"");
          item.Mobile=that.com.PhoneNum(item.Mobile||"");
          that.arrayData.push(item);
        });
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.length;
          if(that.RecordCount == data.Status.length || that.RecordCount == that.arrayData.length)
          {
            that.infiniteScroll.disabled = true;
          }else{
            that.infiniteScroll.disabled = false;
          }
          /****上拉加载数据end****/
      }
 
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  serarEvent(e){ 
    if(e.keyCode == 13){
      this.LoadData(1);
    }else{
      this.LoadData(1);
    }
    
  }

EventLink(item,i){
  const that=this;
  // //debugger;
  console.log(item,"*********************")
  that.com.setHistoryUrl(false);
  that.com.Go("/tabs/contact/QuestionNaire/"+this.com.getNowDatetime,{
    a_ChineseName:item.ChineseName,
    tb_Name:item.Name,
    StartDate:item.StartDate,
    StoreID:item.StoreID,
    UserID:item.UserID
  });
}
}
